import TextAreaControl from './textarea-control';

export default TextAreaControl;